import React from 'react';
import FuturisticHeader from './FuturisticHeader';
import FuturisticFooter from './FuturisticFooter';

interface FuturisticLayoutProps {
  children: React.ReactNode;
}

const FuturisticLayout: React.FC<FuturisticLayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-neu-bg">
      <FuturisticHeader />
      <main className="flex-grow pt-20">
        {children}
      </main>
      <FuturisticFooter />
    </div>
  );
};

export default FuturisticLayout;
